const mainElement = ref<HTMLElement | undefined>()
const topNavControls = ref<HTMLElement | undefined>()

export default function () {
  return { mainElement, topNavControls }
}
